import { CSSProperties, cloneElement, ReactElement } from 'react';
import { twMerge } from 'tailwind-merge';

import BgBottomGradient from '../../assets/bg-bottom-gradient.png';

interface Props<
  C extends ReactElement<{ className?: string; style?: CSSProperties }>,
> {
  className?: string;
  children: C;
}

export function LayoutWithBgGradient<
  C extends ReactElement<{ className?: string; style?: CSSProperties }>,
>(props: Props<C>) {
  return cloneElement(props.children, {
    className: twMerge(
      props.children.props.className,
      'bg-[top_left]',
      'bg-[length:auto_100vh]',
      'bg-repeat-x',
      props.className,
    ),
    style: {
      ...props.children.props.style,
      backgroundImage: `url(${BgBottomGradient})`,
    },
  });
}
